import gql from "graphql-tag"

export default gql`
  fragment dealBirthdayBox on Deal {
    isBirthdayBox
    birthdayBoxMetaData {
      productId
      title
      brandName
      desc
      image
      linkProduct
    }
  }
`
